import {
  accountingConstants,
  agentConstants,
  bankingConstants,
  budgetConstants,
  cardConstants,
  companyConstants,
  expenseConstants,
  invoiceConstants,
  listPageCacheConstants,
  mainConstants,
  subscriptionConstants,
  teamsConstants,
  userConstants,
  vendorsConstants
} from '../constants';
import {request} from '../services/request';
import {authActions} from './auth.actions';
import {mainActions} from './main.actions';
import {invoicesActions} from './invoice.actions';
import {openBankingActions} from './openBanking.actions';
import {transactionActions} from './transaction.actions';
import {localStorageKeysConstants} from '../../constants';
import {backendEndpoints} from '../../api';
import {objectHelpers, teamsHelpers} from '../../utils/helpers';

const {COMPANY_ID, CLOSED_BALANCE_AUTH, SHOW_WELCOME, TOKEN} = localStorageKeysConstants;

const errorHandlerProps = {disableAlert: true};

const authUser = (isAuth) => {
  return {
    type: userConstants.SET_AUTH,
    isAuth
  }
}

const clearUserData = () => {
  return {
    type: userConstants.CLEAR_USER_DATA
  }
}

const getEmployeeProfile = (errorFunc) => {
  return (dispatch, getState) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_USER_EMPLOYEE_CURRENT,
      successCallback: (data) => {
        const {role} = data;
        dispatch({
          type: userConstants.GET_EMPLOYEE_PROFILE,
          user: data,
          isAdmin: teamsHelpers.isAdmin(role),
          isManager: teamsHelpers.isManager(role),
          isSupport: teamsHelpers.isSupport(role),
          isKnownEmployee: true
        });
      },
      errorCallback: (data) => {
        try {
          if (data.response.status === 403) {
            const {companies} = getState().user;
            const currentCompany = companies.find(d => d.company_id !== localStorage.getItem(localStorageKeysConstants.COMPANY_ID));
            if (currentCompany) dispatch(changeCompany(currentCompany.company_id));
            errorFunc && errorFunc(data);
          }
        } catch (e) {
          errorFunc && errorFunc(data);
        }
        dispatch({
          type: userConstants.GET_EMPLOYEE_PROFILE,
          user: {},
          isAdmin: false,
          isManager: false,
          isSupport: false,
          isKnownEmployee: false
        });
        dispatch({type: userConstants.SET_CHECKED_AUTH});
      },
      errorHandlerProps
    });
  }
}

const getEmployeeSettings = (success, error) => {
  return (dispatch) => {
    const updateSettings = (data) => dispatch({ type: userConstants.GET_EMPLOYEE_SETTINGS, data });

    request.get({
      dispatch,
      url: backendEndpoints.GET_USER_CURRENT_SETTINGS,
      successCallback: (data) => {
        updateSettings(data);
        if (success) success();
      },
      errorCallback: () => {
        updateSettings({});
        if (error) error();
      },
      errorHandlerProps
    });
  }
}

const getEmployeeNotificationSettings = (success, error) => {

  return (dispatch) => {
    const updateSettings = (data) => dispatch({ type: userConstants.GET_EMPLOYEE_NOTIFICATION_SETTINGS, data });

    request.get({
      dispatch,
      url: backendEndpoints.GET_USER_CURRENT_NOTIFICATIONS,
      successCallback: (data) => {
        updateSettings(data);
        if (success) success();
      },
      errorCallback: () => {
        updateSettings({});
        if (error) error();
      },
      errorHandlerProps
    });
  }

}

const getUserProfile = (hideLoader = true, showLoading = true) => {
  return (dispatch) => {
    const loading = (status = false) => mainActions.setInitialLoading(status, dispatch);
    const token = JSON.parse(localStorage.getItem(TOKEN));

    const clearStoredSession = () => {
      authActions.logout();
      dispatch(userActions.markedCheckedAuth());
      loading();
    }

    if (token && token.accessToken) {
      showLoading && loading(true);
      request.get({
        dispatch,
        url: backendEndpoints.GET_USER_CURRENT_PROFILE,
        successCallback: (data) => {
          if (localStorage.getItem(SHOW_WELCOME) && data.has_any_company) {
            localStorage.removeItem(SHOW_WELCOME);
          }
          dispatch({
            type: userConstants.GET_USER_PROFILE,
            user: data,
          });
          hideLoader && loading();
        },
        errorCallback: clearStoredSession,
        errorHandlerProps
      });
    } else {
      clearStoredSession();
    }
  }
}

const getCompanies = (handleChangeCompany, callbackHandle) => {
  return (dispatch, getState) => {

    const updateCompanies = (companies) => dispatch({ type: userConstants.GET_COMPANIES, companies });

    const setCompany = (data) => dispatch({ type: companyConstants.SET_COMPANY, data });

    const onChangeCompany = (company) => handleChangeCompany && handleChangeCompany(company);

    request.get({
      dispatch,
      url: backendEndpoints.GET_COMPANIES,
      successCallback: (data) => {
        const {user, company} = getState();

        updateCompanies(data.sort((a, b) => a.name.localeCompare(b.name)));

        if (data.length === 0) {
          localStorage.setItem(SHOW_WELCOME, 'true');
        }

        if (company.id === null) {
          const companyId = objectHelpers.getObjProp(user.employee, 'company_id');
          let currentCompany = data.find(d => d.company_id === companyId && d.account_enabled);
          const firstActiveCompany = data.find(d => d.account_enabled);
          if (currentCompany === undefined && data.length > 0) {
            const company = localStorage.getItem(COMPANY_ID);
            if (company) {
              let foundCompany = data.find(d => d.company_id === company && d.account_enabled);
              if (foundCompany) {
                currentCompany = foundCompany;
              } else {
                currentCompany = firstActiveCompany;
                onChangeCompany(data.find(d => d.company_id === company));
              }
            } else {
              currentCompany = firstActiveCompany;
            }
            currentCompany && dispatch(changeCompany(currentCompany.company_id));
          } else {
            if (companyId) {
              setCompany(currentCompany || {});
            } else {
              const company = firstActiveCompany;
              if (company) setCompany(company);
            }
          }
        } else {
          const companyId = objectHelpers.getObjProp(user.employee, 'company_id');
          const currentCompany = data.find(d => d.company_id === companyId && d.account_enabled);
          currentCompany && setCompany(currentCompany);
        }
        callbackHandle && callbackHandle(data);
      },
      errorCallback: (data) => {
        updateCompanies([]);
        callbackHandle && callbackHandle(data);
      },
      errorHandlerProps
    });
  }
}

// Empties the company data that was still showing the previous company after a switch. Each slice goes
// back to its initial shape, the same one it has before the first load.
//
// Only on a real switch: the refetch for these is keyed on the company id changing, or happens when a
// page mounts (the switch redirects to the overview, so pages do mount afresh). A re-select refetches
// nothing and would leave them blank.
const clearCompanyScopedData = () => {
  return (dispatch) => {
    dispatch({ type: cardConstants.CLEAR_CARDS_DATA });
    dispatch({ type: bankingConstants.CLEAR_CARD_DETAILS });
    dispatch({ type: expenseConstants.CLEAR_EXPENSE_DATA });
    dispatch({ type: subscriptionConstants.CLEAR_SUBSCRIPTIONS_DATA });
    dispatch({ type: budgetConstants.CLEAR_BUDGETS_DATA });
    dispatch({ type: vendorsConstants.CLEAR_VENDORS });
    dispatch({ type: teamsConstants.CLEAR_TEAMS });
    dispatch({ type: invoiceConstants.CLEAR_INVOICES_DATA });
    dispatch({ type: mainConstants.CLEAR_COMPANY_SYSTEM_DATA });
    // Keyed by page name, not company, and restored when the URL matches — so an entry saved before a
    // switch would bring the old company's rows back.
    dispatch({ type: listPageCacheConstants.CLEAR_ALL_LIST_PAGE_CACHE });
  }
}

const changeCompany = (companyId, errorFunc) => {
  return (dispatch, getState) => {
    const {companies} = getState().user;
    const previousCompanyId = getState().company?.id;
    const currentCompany = companies.find(d => d.company_id === companyId);
    // `|| {}` used to blank the slot outright: SET_COMPANY maps company_id/name/country, so an empty
    // payload produced id null, name null and country '' for a company that exists and is simply not
    // in the list yet — e.g. straight after creating one. Every country-gated surface then silently
    // switched off (H1MVP-4795). Keeping the id at least leaves company-scoped requests pointed at
    // the right company instead of at nothing.
    //
    // ⚠ This does NOT fully repair the slot: name and country are still unknown until the company
    // list is refetched, and `getCompanies` only assigns a company when `company.id === null`, so it
    // will not correct this one on its own. Closing that needs a fetch-one-company path.
    dispatch({
      type: companyConstants.SET_COMPANY,
      data: currentCompany || {company_id: companyId}
    });
    dispatch({ type: bankingConstants.CLEAR_CARDS_DATA });
    dispatch({ type: userConstants.CLEAR_NOTIFICATIONS });
    dispatch({ type: mainConstants.CLEAR_MAIN_DATA });
    dispatch({ type: agentConstants.CLEAR_AGENT_DATA });
    // Holds the ERP mode — see CLEAR_ACCOUNTING_DATA in the accounting reducer for why keeping it
    // across a company switch renders the wrong ERP's UI.
    //
    // ⚠ ONLY on a real switch, unlike the clears above. This one resets `companySettingsResolved`
    // to false, and the refetch that would set it back is an effect keyed on the company id
    // CHANGING (UserCompanyInitializer). Clearing unconditionally means a call for the company
    // already selected — a re-select, or a retry — takes the accounting nav away and never puts it
    // back, for the rest of the session. That is a worse bug than the one being fixed.
    if (previousCompanyId && previousCompanyId !== companyId) {
      dispatch({ type: accountingConstants.CLEAR_ACCOUNTING_DATA });
      dispatch(clearCompanyScopedData());
    }
    dispatch(openBankingActions.clearOpenBankingData());
    dispatch(transactionActions.clearBankingDetails());
    dispatch(invoicesActions.clearInvoicesListTableData());
    localStorage.setItem(COMPANY_ID, companyId);
    localStorage.removeItem(CLOSED_BALANCE_AUTH)
    if (currentCompany && errorFunc) {
      dispatch(userActions.getEmployeeProfile(() => errorFunc(currentCompany)))
    } else {
      dispatch(userActions.getEmployeeProfile())
    }
  }
}

const markedCheckedAuth = () => {
  return (dispatch) => {
    dispatch({type: userConstants.SET_CHECKED_AUTH});
  }
}

const changeEmployeePassword = (data, successCallback, errorCallback) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_USER_CURRENT_CHANGE_PASSWORD,
      data,
      successCallback,
      errorCallback: (errors) => {
        let data;
        try {
          data = errors.response.data;
        } catch {}
        errorCallback && errorCallback(data);
      },
      errorHandlerProps
    });
  }
}

const updateEmployeeEmailNotifications = (data, successCallback, errorCallback) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_USER_CURRENT_UPDATE_EMAIL_NOTIFICATIONS,
      data,
      successCallback,
      errorCallback
    });
  }
}

const updateEmployeeInformation = (data, success, error) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_USER_CURRENT_SETTINGS,
      data,
      successCallback: (data) => success && success(data),
      errorCallback: (resp) => error && error(resp),
      errorHandlerProps
    });
  }
}

const getUnreadNotifications = () => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_NOTIFICATIONS_COMPANY_UNREAD,
      successCallback: (data) => {
        dispatch({
          type: userConstants.SUCCESS_GET_UNREAD_NOTIFICATIONS_BY_COMPANY,
          data: data.companies.filter(c => c.has_notifications).map(c => c.company_id)
        });
      },
      errorCallback: () => dispatch({type: userConstants.ERROR_GET_UNREAD_NOTIFICATIONS_BY_COMPANY}),
      errorHandlerProps
    });
  }
}

const updateNotifications = (data) => {
  return (dispatch) => {
    dispatch({type: userConstants.GET_NOTIFICATIONS_LIST, data});
  }
}

const updateNotificationsCount = (data= {read: 0, unread: 0}) => {
  return (dispatch) => {
    dispatch({type: userConstants.GET_NOTIFICATIONS_COUNT, data});
  }
}

const getNotificationsCount = ({successCallback, errorCallback}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_NOTIFICATIONS_COUNT,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getNotificationList = (loadMore = false) => {
  return (dispatch, getState) => {
    let url = backendEndpoints.GET_NOTIFICATIONS;
    if (loadMore) {
      const {next_page: nextPage, cursor} = getState().user.notifications.pagination;
      if (nextPage) url += `?cursor=${cursor}`;
    }
    request.get({
      dispatch,
      url,
      successCallback: (data) => {
        const {notifications, pagination} = data;
        dispatch(updateNotifications({
          pagination,
          notifications: loadMore ? [...getState().user.notifications.notifications, ...notifications] : notifications
        }));
        dispatch(getUnreadNotifications());
      },
      errorCallback: () => dispatch(updateNotifications([]))
    });
  }
}

const getNotificationsListWithCount = (loadMore = false) => {
  return (dispatch, getState) => {
    const {notificationCount} = getState().user;

    dispatch(getNotificationsCount({
      successCallback: (data) => {
        const {total_read: read, total_unread: unread} = data;

        if ((notificationCount.read !== read || notificationCount.unread !== unread) || loadMore) {
          dispatch(updateNotificationsCount({read, unread}));
          dispatch(getNotificationList(loadMore));
        }
      },
      errorCallback: () => dispatch(updateNotificationsCount({read: 0, unread: 0}))
    }));
  }
}

const readNotifications = ({ids = [], successCallback, errorCallback} = {}) => {
  return (dispatch, getState) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_NOTIFICATIONS_STATUS_UPDATE,
      data: {notifications_ids: ids},
      successCallback: () => {
        const {notifications, notificationCount} = getState().user;
        let foundNotificationCount = 0;
        const notificationList = notifications.notifications.map(n => {
          if (ids.includes(n.id)) {
            foundNotificationCount++;
            return {...n, is_read: true}
          } else {
            return n;
          }
        });
        dispatch({
          type: userConstants.READ_NOTIFICATIONS,
          notifications: {
            ...notifications,
            notifications: notificationList
          },
          notificationCount: {
            read: notificationCount.read + foundNotificationCount,
            unread: notificationCount.unread - foundNotificationCount
          }
        });
        successCallback?.();
      },
      errorCallback: (errors) => {
        const {data} = errors.response;
        errorCallback?.(data);
      },
      errorHandlerProps
    });
  }
}

const readAllNotifications = (success, error) => {
  return (dispatch, getState) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_NOTIFICATIONS_READ_ALL,
      successCallback: (data) => {
        const {notifications, notificationCount, employee, companiesWithNotifications} = getState().user;
        dispatch({
          type: userConstants.READ_ALL_NOTIFICATIONS,
          notifications: {
            ...notifications,
            notifications: notifications.notifications.map(n => {
              return {...n, is_read: true}
            })
          },
          notificationCount: {
            read: notificationCount.read + notificationCount.unread,
            unread: 0
          }
        });
        dispatch({
          type: userConstants.SUCCESS_GET_UNREAD_NOTIFICATIONS_BY_COMPANY,
          data: companiesWithNotifications.filter(c => c !== employee.company_id)
        })
        success && success(data);
      },
      errorCallback: (data) => error && error(data),
      errorHandlerProps
    })
  }
}

const disableEmployeeFromCompany = (isDisabled = false, company) => {
  return (dispatch) => {
    dispatch({
      type: userConstants.DISABLED_FROM_COMPANY,
      data: isDisabled ? {
        isDisabled,
        company
      } : null
    });
  }
}

const sendEmailVerification = (email, success, error) => {
  return verificationRequestTemplate(
    {email},
    backendEndpoints.PUT_USER_CURRENT_EMAIL_VERIFICATION_START,
    'SEND_USER_EMAIL_VERIFICATION',
    success,
    error,
    false
  );
}

const finishEmailVerification = (token, success, error) => {
  return verificationRequestTemplate(
    {token},
    backendEndpoints.PUT_USER_CURRENT_EMAIL_VERIFICATION_FINISH,
    'FINISH_USER_EMAIL_VERIFICATION',
    success,
    error,
    false,
    errorHandlerProps
  );
}

const startPhoneVerification = ({data, successCallback, errorCallback}) => phoneVerificationTemplate(data, backendEndpoints.PUT_USER_CURRENT_PHONE_VERIFICATION_START, successCallback, errorCallback);

const endPhoneVerification = (data, success, error) => phoneVerificationTemplate(data, backendEndpoints.PUT_USER_CURRENT_PHONE_VERIFICATION_FINISH, success, error, errorHandlerProps);

const verificationRequestTemplate = (data, url, dispatchTypeName, success, error, showLoader = true, errorHandlerProps = {}) => {
  return (dispatch) => {
    const loading = (loadingStatus) => showLoader && mainActions.setLoading(loadingStatus, dispatch);
    loading(true);
    request.put({
      dispatch,
      url,
      data,
      successCallback: (data) => {
        dispatch({
          type: userConstants[`SUCCESS_${dispatchTypeName}`],
          data
        });
        loading(false);
        if (success) success(data);
      },
      errorCallback: (err) => {
        const {data} = err.response;
        if (error) error(data);
        loading(false);
        dispatch({
          type: userConstants[`ERROR_${dispatchTypeName}`],
          data
        });
      },
      errorHandlerProps
    });
  }
}

const phoneVerificationTemplate = (data, url, success, error, requestProps) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url,
      data,
      successCallback: (response) => success && success(response),
      errorCallback: (err) => {
        if (err && err.hasOwnProperty('response') && err.response !== undefined) {
          data = err.response.data;
          error && error(data);
        }
      },
      errorHandlerProps: requestProps
    });
  }
}

const getEmployeePopupSettings = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_USER_EMPLOYEE_POPUP_SETTINGS,
      data,
      successCallback: (data) => {
        dispatch({
          type: userConstants.GET_EMPLOYEE_POPUP_SETTINGS,
          data
        });
        successCallback && successCallback(data);
      },
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateEmployeePopupSettings = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.PUT_USER_EMPLOYEE_POPUP_SETTINGS,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

export const userActions = {
  authUser,
  clearUserData,
  getEmployeeProfile,
  getEmployeeSettings,
  getEmployeeNotificationSettings,
  getUserProfile,
  getCompanies,
  markedCheckedAuth,
  changeCompany,
  changeEmployeePassword,
  updateEmployeeEmailNotifications,
  updateEmployeeInformation,
  getNotificationList,
  getNotificationsListWithCount,
  readNotifications,
  readAllNotifications,
  updateNotificationsCount,
  sendEmailVerification,
  finishEmailVerification,
  disableEmployeeFromCompany,

  startPhoneVerification,
  endPhoneVerification,

  getEmployeePopupSettings,
  updateEmployeePopupSettings,
};
